// extracted by mini-css-extract-plugin
export default {"skelton":"styles_skelton__pE06Z","example":"styles_example__oy0t+"};